/** HTML Media Capture. Always `environment` + JPEG so Android Chrome
 * writes a full-size file URI. Bare `capture` uses ACTION_IMAGE_CAPTURE
 * without EXTRA_OUTPUT and returns a ~480x680 thumbnail bitmap. */
export function nativeRearCameraCapture(_userAgent: string): {
  accept: "image/jpeg";
  capture: "environment";
} {
  return { accept: "image/jpeg", capture: "environment" };
}
